'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _rtlDetect = require('rtl-detect');var _rtlDetect2 = _interopRequireDefault(_rtlDetect);
var _services = require('../../../services');

var _NoteInput = require('../NoteInput.scss');var styles = _interopRequireWildcard(_NoteInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var FormattedNote = function (_Component) {_inherits(FormattedNote, _Component);function FormattedNote() {var _temp, _this, _ret;_classCallCheck(this, FormattedNote);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.















    setNoteDirection = function (_ref) {var language = _ref.language;
      if (!language) {
        return;
      }

      _this.note.classList.add(_rtlDetect2.default.getLangDir(language));
    }, _this.

    checkNoteLanguage = function () {
      _this.note && _services.TranslationService.
      suggestStringLanguage(_this.note.textContent).
      then(_this.setNoteDirection);
    }, _temp), _possibleConstructorReturn(_this, _ret);}FormattedNote.prototype.componentDidMount = function componentDidMount() {this.note.innerHTML = this.props.content;setTimeout(this.checkNoteLanguage);};FormattedNote.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {var content = _ref2.content;if (this.props.content !== content) {this.note.innerHTML = content;}};FormattedNote.prototype.shouldComponentUpdate = function shouldComponentUpdate() {return false;};FormattedNote.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: styles.noteContent, ref: function ref(note) {_this2.note = note;} }));

  };return FormattedNote;}(_react.Component);exports.default = FormattedNote;


FormattedNote.propTypes = {
  content: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notes/HelpComponents/FormattedNote.js
// module id = 2739
// module chunks = 0